import * as React from 'react';
import { Input } from '@/components/forms/ui/input';

type Props = {
  id?: string;
  value: string | undefined;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
};

export function NameField({ id, value, onChange, onBlur, error }: Props) {
  return (
    <div className="flex-1">
      <Input
        id={id}
        value={value ?? ''}
        placeholder="Name this Line Item"
        data-testid="line-item-name-field"
        onChange={e => onChange(e.target.value)}
        onBlur={onBlur}
        aria-invalid={error ? true : undefined}
      />
      {error ? <span className="text-destructive text-sm">{error}</span> : null}
    </div>
  );
}
